import React, { Fragment, useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import imageCompression from 'browser-image-compression';

const FileUpload = ({
                        onChange,
                        children,
                        documentUploadUrl = null,
                        documentUrlData,
                        multiple = false,
                        accept = 'image/*',
                        id,
                        value = '',
                        isBase64 = false,
                        reset = true,
                        capture = true,
                        onLoading,
                        isPublic = false,
                        prefilledFilename,
                        dataObject,
                        variable,
                        index
                    }) => {
    const inputFile = useRef(null);
    const [fileName, setFileName] = useState('');
    const [base64Url, setbase64Url] = useState();
    const [addedFiles, setAddedFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // useEffect(() => {
    //   (() =>{ onLoading(isLoading)})();
    // },[isLoading]);

    const handleFileChange = (event) => {
        let val = event.target.files;
        if (val) {
            if (multiple) {
                let fileLength = val.length;
                setIsLoading(true);
                function readAndPreview(file) {
                    var options = {
                        maxSizeMB: 20,
                        maxWidthOrHeight: 700,
                        useWebWorker: true
                    }
                    imageCompression(file, options)
                        .then(function (compressedFile) {
                            /// send images
                            let reader = new FileReader();
                            reader.onload = async function (e) {
                                if (documentUploadUrl !== null && documentUploadUrl !== undefined) {

                                    const res = await documentUploadUrl({
                                        base_64_file: this.result,
                                    });
                                    addedFiles.push(res?.file_url);
                                    onChange([...addedFiles]);
                                    setFileName(
                                        `${fileLength} ${file.type.split('/')[0]}${
                                            fileLength > 1 ? 's' : ''
                                        }`
                                    );
                                    setIsLoading(false);
                                }
                            };
                            reader.readAsDataURL(compressedFile);

                            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

                            // return uploadToServer(compressedFile); // write your own logic
                        })
                        .catch(function (error) {
                            let reader = new FileReader();
                            reader.onload = async function (e) {
                                if (documentUploadUrl !== null && documentUploadUrl !== undefined) {

                                    const res = await documentUploadUrl({
                                        base_64_file: this.result,
                                    });
                                    addedFiles.push(res?.file_url);
                                    onChange([...addedFiles]);
                                    setFileName(
                                        `${fileLength} ${file.type.split('/')[0]}${
                                            fileLength > 1 ? 's' : ''
                                        }`
                                    );
                                    setIsLoading(false);
                                }
                            };
                            reader.readAsDataURL(file);
                        });

                }
                // function readAndPreviews(file) {
                // let reader = new FileReader();
                // reader.onload = async function () {
                //   if (documentUploadUrl !== null && documentUploadUrl !== undefined) {

                //     const res = await documentUploadUrl({
                //       base_64_file: this.result,
                //     });
                //     addedFiles.push(res?.file_url);
                //     onChange([...addedFiles]);
                //     setFileName(
                //       `${fileLength} ${file.type.split('/')[0]}${
                //         fileLength > 1 ? 's' : ''
                //       }`
                //     );
                //     setIsLoading(false);
                //   }
                // };
                // reader.readAsDataURL(file);
                // }
                if (val) {
                    [].forEach.call(val, readAndPreview);
                }
            } else {
                let fileName = val[0].name.replace(/\.[^/.]+$/, '');
                setIsLoading(true);
                let Fl = new FileReader();
                Fl.onload = async () => {
                    if (isBase64) {
                        setbase64Url(Fl.result);
                        onChange(Fl.result);
                        setFileName(fileName);
                        setIsLoading(false);
                    } else {
                        if (Fl.result && documentUploadUrl) {
                            const res = await documentUploadUrl({ base_64_file: Fl.result });
                            if (res) {
                                onChange(res?.file_url);
                                setFileName(fileName);
                                setIsLoading(false);
                            }
                        }
                    }
                };
                Fl.readAsDataURL(val[0]);
            }
        }
    };

    useEffect(() => {
        if (
            prefilledFilename !== undefined &&
            prefilledFilename !== null
        ) {
            setTimeout(() => {
                setFileName(prefilledFilename);
            }, 100);
        }
    }, [prefilledFilename]);

    useEffect(() => {
        if (reset) {
            remvoeFile();
        }
    }, [reset]);

    const remvoeFile = () => {
        setFileName('');
        setAddedFiles([]);
        onChange('');
        inputFile.current.value = '';
        if(dataObject !== undefined && dataObject[variable] !== undefined){
             dataObject[variable] = ''
        }

        // if(documentUrlData['file_url'] !== undefined){
        //     delete documentUrlData['file_url']
        // }
    };

    return (
        <Fragment>
            {fileName.length ? (
                <Fragment>
          <span className="btn btn-primary ">
            {fileName}
              <span
                  onClick={remvoeFile}
                  className="remove-icon"
                  role="img"
                  aria-label="close"
              >
              &#10060;
            </span>
          </span>
                </Fragment>
            ) : null}
            <span className={`${fileName.length ? 'd-none' : 'd-inline-block'}`}>
        <label htmlFor={id} className="p-2 rounded">{children}</label>
        {/* <label htmlFor={id} className="btn-primary p-2 rounded">{children}</label> */}
                {isLoading ? <span>Loading...</span> : null}
                <input
                    // className="d-none"
                    type="file"
                    id={id}
                    accept={accept}
                    multiple={multiple ? true : false}
                    //capture = {multiple ? false : (capture ? true : false)}
                    value={value}
                    ref={inputFile}
                    onChange={handleFileChange}
                />
      </span>
        </Fragment>
    );
};

FileUpload.propTypes = {
    onChange: PropTypes.func,
    base_64_file: PropTypes.func,
    multiple: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    value: PropTypes.string,
};

export default FileUpload;
